import ApprovalDialog from "@/admin/dashboard/components/approval-dialog/ApprovalDialog";
import ApprovalTypeTag from "@/components/tags/ApprovalTypeTag";
import { Button } from "@/components/ui/button";
import { ApprovalType, LeaveRequest, LeaveRequestDTO } from "@/models/leave-requests.model";
import { toDateFormatted } from "@/utils/date-format";
import { capitalizeFirstLetter } from "@/utils/string-format";
import { ColumnDef } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import { SetStateAction } from "react";

// const ActionCell = ({ row }: { row: any }) => {
//   return <ApprovalDialog requestObj={row.original} />;
// };
export const columns = (): ColumnDef<LeaveRequestDTO>[] => [
  {
    id: "employee",
    accessorFn: (row) => `${row.user.fullName}`,
    header: "Employee",
  },
  {
    id: "type",
    accessorFn: (row) => row.type,
    header: "Leave Type",
    cell: ({ row }) => {

      return <span>{capitalizeFirstLetter(row.original.type)}</span>;
    },
    filterFn: (row, id, value) => {
      return value.includes(String(row.getValue(id)).toUpperCase());
    },
  },
  {
    id: "startDate",
    cell: ({ row }) => {
      return (
        <span>
          {toDateFormatted(row.original.fromDate)}{" "}
          {row.original.fromDateIsAm ? "AM" : "PM"}
        </span>
      );
    },
    accessorFn: (row) => row.fromDate,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2">
          Start Date
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },
  {
    id: "endDate",
    cell: ({ row }) => {
      return (
        <span>
          {toDateFormatted(row.original.toDate)}{" "}
          {row.original.toDateIsAm ? "AM" : "PM"}
        </span>
      );
    },
    accessorFn: (row) => row.toDate,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2">
          End Date
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },
  {
    accessorFn: (row) => row.days,
    header: "Days",
    cell: ({ row }) => {
      return <span className="w-full">{row.original.days}</span>;
    },
  },
  {
    id: "status",
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      return <ApprovalTypeTag status={row.original.status} />;
    },
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
  },
  {
    id: "requestedAt",
    cell: ({ row }) => {
      return <span>{toDateFormatted(row.original.createdAt)}</span>;
    },
    accessorFn: (row) => row.createdAt,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2">
          Requested On
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },
  {
    id: "action",
    cell: ({ row }) => (
      <ApprovalDialog
        requestObj={row.original}

      />
    ),
  },
];
